import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

class Utils {

 static parseGoogleDirections(addressComponent){
   var result = {
     country: null,
     state: null,
     city: null
   }
   for(var p in addressComponent){
     let component = addressComponent[p]
     for(var t in component.types){
       switch (component.types[t]) {
         case 'locality':
           result.city = component.long_name
           break;
         case 'administrative_area_level_1':
            result.state = component.long_name
           break;
        case 'country':
          result.country = component.long_name
          break;
         default:

       }
     }
   }
   return result
 }

 static parseTime(timeString){
   timeString = timeString.toLowerCase()
   let amIndex = timeString.indexOf("am")
   let pmIndex = timeString.indexOf("pm")
   let ampmIndex = amIndex > pmIndex ? amIndex : pmIndex;
   var splitTime = null
   if(ampmIndex > 0){
     let ampm = timeString.slice(ampmIndex,ampmIndex+2).toLowerCase()
     timeString = timeString.slice(0,ampmIndex)
     splitTime = timeString.split(":")
     splitTime[0] = parseInt(splitTime[0])
     splitTime[1] = parseInt(splitTime[1])
     if(ampm == "am" && splitTime[0] == 12){
       splitTime[0] = 0
     }else if(ampm == "pm"){
       splitTime[0] = splitTime[0] == 12 ? splitTime[0] : splitTime[0] + 12
     }
   }else{
     splitTime = timeString.split(":")
     splitTime[0] = parseInt(splitTime[0])
     splitTime[1] = parseInt(splitTime[1])
   }
   return {hours:splitTime[0],minutes:splitTime [1]}
 }

 static sumMinutes(time,minutes){
   minutes = parseInt(minutes)
   var resultTime = {hours:time.hours,minutes:time.minutes}
   resultTime.minutes += minutes
   if(resultTime.minutes >= 60){
     let hours = Math.floor(resultTime.minutes /60)
     resultTime.minutes -= hours * 60
     resultTime.hours += hours
   }
   if(resultTime.hours > 23){
     resultTime.hours = 23
     resultTime.minutes = 59
   }
   return resultTime;
 }

 static getDayPercent(time){
   let minutesInADay = 24 * 60
   let currentTimeMinutes = (time.hours * 60) + time.minutes
   return (currentTimeMinutes/minutesInADay) * 100
 }

 /*MOMENT UTILS*/

static  overlapsByDurarion(date1,date2,duration1,duration2){
  let range1 = moment.rangeFromInterval('minute',duration1,date1)
  let range2 = moment.rangeFromInterval('minute',duration2,date2)
  return range1.overlaps(range2)
}

static  overlapsByDates(initialDate1,initialDate2,finalDate1,finalDate2){
  let range1 = moment.range(initialDate1,finalDate1)
  let range2 = moment.range(initialDate2,finalDate2)
  return range1.overlaps(range2)
}

  static setTableOverflowClass (tableElement) {
    const tableWrappersArray = document.querySelectorAll(tableElement)
    tableWrappersArray.forEach(element => {
      element.addEventListener('scroll', (e) => {
        if (e.target.scrollLeft > 2) {
          e.target.classList.add('has-scroll')
        } else if (e.target.scrollLeft < 2 && e.target.classList.contains('has-scroll')) {
          e.target.classList.remove('has-scroll')
        }
      })
    })
  }

/**/
}

export default Utils



// WEBPACK FOOTER //
// ./src/utils/utils.js